import React from 'react';
import Image from './Image';
import Blocks from '@/assets/images/Blocks.svg';
import Line from '@/assets/images/LineShort.svg';

const Banner = () => {

  return (
    <div className='relative'>
      <div 
        className='w-full pt-[265px] pb-[441px] bg-cover bg-center'
        style={{backgroundImage: `url(${Blocks})`}}
        data-aos="fade-up"
        data-aos-delay="200"
        data-aos-duration="300"
        data-aos-easing="ease-in-out"
      >
        <div className='main_container gradient_bg_text bg-grad-title text-center text-[60px] font-bold leading-[78px] tracking-[-1.6px]'>
          Addressing technical challenges<br/> for blockchain enterprises.
        </div>
      </div>
      <div 
        className='absolute bottom-0 flex justify-center w-full'
        data-aos="fade-down"
        data-aos-delay="200"
        data-aos-distance="1500px"
        data-aos-duration="300"
        data-aos-easing="ease-in-out"
      >
        <Image src={Line} className='-mt-8' alt='Line'/>
      </div>
    </div>
    )
}

export default Banner;